import { useGetCheckoutCouponsByCouponCode } from "@birdwatch/client";

/**
 * The campaign coupon, read for display.
 *
 * `GET /checkout/coupons/:code` is public and read-only, so this works on the signed-out
 * steps too — which is the point: the sign-up card names the coupon before anyone has
 * pressed anything.
 *
 * There is no presale-side mutation twin any more. Applying a code at checkout goes
 * through the member checkout's `PromoCode`, which validates with `useCheckDiscountCode`
 * and writes the code to the purchase intent for the server to re-price from.
 */
export const usePresaleCouponDetail = (couponCode: string) =>
  useGetCheckoutCouponsByCouponCode({ couponCode }).get({
    enabled: !!couponCode,
  });
